<template>
  <div class="all-users-page">
    <h1 class="page-header color-1-100">All users</h1>
    <div class="admin-gm-breadcrumbs background-2-16-after" tabindex="-1" v-if="getUserRole === 'gm'">
      <router-link class="companies background-1-100-after color-2-77" :to="{name: 'companies'}">Companies</router-link>
      <router-link class="all-users background-1-100-after color-2-77 active" :to="{name: 'users'}">Users</router-link>
      <!--<router-link class="ask-expert" :to="{name: 'AskExperts'}" v-if="getUserRole !== 'gm'">Ask an Expert</router-link>-->
    </div>
    <div class="content-section">
      <div class="data-list-heading">
        <div class="data-list-statusbar border-1-20 background-1-20 color-2-100">
          <div class="data-list-statusbar__contains data-list-statusbar__block">{{ usersSum }} users</div>
        </div>
        <router-link :to="{name: getUserRole === 'gm' ? 'add-user' : 'ca-add-user'}"
                     class="data-list-add data-list-add-custom border-1-40 color-2-100">
          <span class="data-list-add-icon color-1-100">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve">
            <polygon id="XMLID_2_" class="st0" points="8.8,6.2 15,6.2 15,8.8 8.8,8.8 8.8,15 6.2,15 6.2,8.8 0,8.8 0,6.2 6.2,6.2 6.2,0 8.8,0"/>
          </svg>
          </span>
          Add new user
        </router-link>
      </div>
      <button @click="csvExport(csvData)"
              v-if="this.users.length && getUserRole === 'gm'"
              class="csv-download-button"
      >Export all users</button>
      <a href="#" id="csvDownload" style="position: fixed; left: -2000px; bottom: -2000px;">download users</a>
      <div class="data-list-selected-filters border-1-40" v-if="getDeviceType('desktop') && selectedFilters.length">
        <div class="data-list-selected-filters-applied data-list-selected-filters-applied-custom background-1-40 color-2-100">
          <span class="data-list-selected-filters-applied-icon color-1-100">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="482.41 -477.986 963.167 971.987" style="enable-background:new 482.41 -477.986 963.167 971.987;" xml:space="preserve">
              <g>
                <path class="st0" d="M848.216-18.686c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3
                  c16.5-19.8,25.6-29.601,25.6-49.2v-272.8c0-15,5.7-29.5,15.8-40.601l353.799-383.899c26.5-28.8,6.101-75.5-33.1-75.5h-873
                  c-39.2,0-59.7,46.6-33.1,75.5L848.216-18.686z"/>
              </g>
            </svg>
          </span>
          <span>Filters applied:<br/>{{ this.editedUsers.length }} results</span>
        </div>
        <div class="data-list-selected-filters-body">
          <button v-for="filter in selectedFilters"
                  class="data-list-selected-filters-body-button-custom background-1-20 color-2-100"
                  type="button"
                  @click.prevent="removeSelectedFilters(filter)"
                  @mouseover="addHoverElement([filter])"
                  @mouseleave="removeHoverElements"
                  :class="{'hover-filter-element': isExist(filter)}">
            <span>{{ filter.label }}</span>
            <span class="data-list-selected-filters-body-button-icon color-1-100">
              <svg class="color-1-100" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 15.002 15.002" style="enable-background:new 0 0 15.002 15.002;" xml:space="preserve">
                <polygon id="XMLID_2_" class="st0" points="7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208
                  12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "/>
                </svg>
            </span>
          </button>
          <a href="#" class="data-list-selected-filters-remove-all color-2-100"
                tabindex="0"
                @click.prevent="removeAllFilters"
                @mouseover="statusbar.filter.isHover = true"
                @mouseleave="statusbar.filter.isHover = false">Clear all filters</a>
        </div>
      </div>
      <div class="data-list-body">
        <table class="table table-data border-1-20">
          <thead class="table-head-mobile-custom background-1-40-before border-1-40" v-bind:filters="getTabletFiltersAppliedText()">
          <span class="table-head-mobile-icon color-1-100">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="482.41 -477.986 963.167 971.987" style="enable-background:new 482.41 -477.986 963.167 971.987;" xml:space="preserve">
              <g>
                <path class="st0" d="M848.216-18.686c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3
                  c16.5-19.8,25.6-29.601,25.6-49.2v-272.8c0-15,5.7-29.5,15.8-40.601l353.799-383.899c26.5-28.8,6.101-75.5-33.1-75.5h-873
                  c-39.2,0-59.7,46.6-33.1,75.5L848.216-18.686z"/>
              </g>
            </svg>
          </span>
          <tr class="inside-table-filters" v-if="(getDeviceType('tablet') || getDeviceType('mobile')) &&  selectedFilters.length">
            <th colspan="9" scope="col" >
              <div class="data-list-selected-filters-body">
                <button v-for="filter in selectedFilters"
                        class="data-list-selected-filters-body-button-custom background-1-20 color-2-100"
                        type="button"
                        @click="removeSelectedFilters(filter)"
                        @mouseover="addHoverElement([filter])"
                        @mouseleave="removeHoverElements"
                        :class="{'hover-filter-element': isExist(filter)}">
                  <span>{{ filter.label }}</span>
                  <span class="data-list-selected-filters-body-button-icon color-1-100">
                    <svg class="color-1-100" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 15.002 15.002" style="enable-background:new 0 0 15.002 15.002;" xml:space="preserve">
                      <polygon id="XMLID_2_" class="st0" points="7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208
                        12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "/>
                      </svg>
                  </span>
                </button>
                <span class="data-list-selected-filters-remove-all"
                      @click="removeAllFilters"
                      @mouseover="statusbar.filter.isHover = true"
                      @mouseleave="statusbar.filter.isHover = false">Clear all filters</span>
              </div>
            </th>
          </tr>
          <tr>
            <th class="data-list-search-col text-left column-search-head table-head-ceil background-1-10 border-1-20" colspan="2"
                scope="col"
                :class="{'active-ceil-head': filerTableHead.selectedCeil === 1,
                'hover-head-ceil': isExistSearchInOptions('name')}"
                @mouseover="addSearchHoverElement('name')"
                @mouseleave="removeSearchHoverElements">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                    title="Full name"
                    aria-label="Full name"
                    v-model="searchByName"
                    type="search"
                    class="table-search"
                    placeholder="Full name" />
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th class="column-email-head table-head-ceil background-1-10 border-1-20"
                scope="col"
                :class="{'active-ceil-head': filerTableHead.selectedCeil === 2,
                'hover-head-ceil': isExistSearchInOptions('email')}"
                @mouseover="addSearchHoverElement('email')"
                @mouseleave="removeSearchHoverElements">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                    title="Email"
                    aria-label="Email"
                    v-model="searchEmail"
                    type="search"
                    class="table-search"
                    placeholder="Email" />
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th class="column-role-head table-head-hover table-head-ceil background-1-10 border-1-20"
                scope="col"
                :class="{'active-ceil-head': filerTableHead.selectedCeil === 3,
                'hover-head-ceil': isExistInOptions(getRolesForSelect)}"
                @click.stop="showHideSubMenu(3)"
                @mouseover="addHoverElement(getRolesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 3}">
                <div class="caption-head-text">
                  <button class="caption-head-inner-text" style="line-height: 28px;">Role</button>
                </div>
              </div>
              <div class="wrap-dropdown-table-head border-1-20"
                   id="sub-menu-2"
                   v-show="filerTableHead.selectedCeil === 3"
                   tabindex="0"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getRolesForSelect"
                            :class="table-head-search"
                            v-model="role" />
              </div>
            </th>
            <th class="column-company-head table-head-hover table-head-ceil background-1-10 border-1-20"
                scope="col"
                :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 4,
                'active-ceil-head': filerTableHead.selectedCeil === 4,
                'hover-head-ceil': isExistInOptions(getTitlesForSelect)}"
                @click.stop="showHideSubMenu(4)"
                @mouseover="addHoverElement(getTitlesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 4}">
                <div class="caption-head-text">
                  <button class="caption-head-inner-text" style="line-height: 28px;">Title</button>
                </div>
              </div>
              <div class="wrap-dropdown-table-head border-1-20"
                   id="sub-menu-3"
                   v-show="filerTableHead.selectedCeil === 4"
                   tabindex="0"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getTitlesForSelect"
                            v-model="job_title" />
              </div>
            </th>
            <th class="column-company-head table-head-hover table-head-ceil background-1-10 border-1-20"
                scope="col"
                v-if="getUserRole === 'gm'"
                :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 5,
                'active-ceil-head': filerTableHead.selectedCeil === 5,
                'hover-head-ceil': isExistInOptions(getCompaniesForSelect)}"
                @click.stop="showHideSubMenu(5)"
                @mouseover="addHoverElement(getCompaniesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 5}">
                <div class="caption-head-text">
                  <button class="caption-head-inner-text" style="line-height: 28px;">Company</button>
                </div>
              </div>
              <div class="wrap-dropdown-table-head border-1-20"
                   id="sub-menu-4"
                   v-show="filerTableHead.selectedCeil === 5"
                   tabindex="0"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getCompaniesForSelect"
                            v-model="company" />
              </div>
            </th>
            <th class="column-created-head table-head-ceil background-1-10 border-1-20"
                scope="col"
                @click.stop="changeOrderBy('created', true)">
              <div class="caption-head caption-head-order">
                <div class="caption-head-text">
                  <button class="caption-head-inner-text">Created <br/>on</button>
                </div>
                <div class="caption-head-order-change">
                  <div class="caption-head-order-up background-1-20"
                       :class="{'active': this.userOrderBy !== null && this.userOrderBy.type === 'created' && this.userOrderBy.order}"></div>
                  <div class="caption-head-order-down background-1-20"
                       :class="{'active': this.userOrderBy !== null && this.userOrderBy.type === 'created' && !this.userOrderBy.order}"></div>
                </div>
              </div>
            </th>
            <th class="column-active-head table-head-ceil background-1-10 border-1-20"
                scope="col"
                @click.stop="changeOrderBy('login', true)">
              <div class="caption-head caption-head-order">
                <div class="caption-head-text">
                  <button class="caption-head-inner-text" style="line-height: 28px;">Last login</button>
                </div>
                <div class="caption-head-order-change">
                  <div class="caption-head-order-up background-1-20"
                       :class="{'active': this.userOrderBy !== null && this.userOrderBy.type === 'login' && this.userOrderBy.order}"></div>
                  <div class="caption-head-order-down background-1-20"
                       :class="{'active': this.userOrderBy !== null && this.userOrderBy.type === 'login' && !this.userOrderBy.order}"></div>
                </div>
              </div>
            </th>
            <th class="column-status-head table-head-ceil background-1-10 border-1-20"
                scope="col"
                :class="{'hover-head-ceil': isExistInOptions(getStatusesForSelect)}"
                @click.stop="showHideSubMenu(7)"
                @mouseover="addHoverElement(getStatusesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 7}">
                <div class="caption-head-text">
                  <button class="caption-head-inner-text">Status</button>
                </div>
              </div>
              <div class="wrap-dropdown-table-head border-1-20"
                   id="sub-menu-7"
                   v-show="filerTableHead.selectedCeil === 7"
                   tabindex="0"
                   @click.stop="">
                <app-select placeholder="Search"
                            :multiple="true"
                            :options="getStatusesForSelect"
                            v-model="userStatus" />
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(user, i) in editedUsers"
              @keyup.enter="goToUserEdit(user.id)"
              @click.prevent="goToUserEdit(user.id)" tabindex="0" v-if="i < offset">
            <td class="id-cell text-center cellpadding border-1-20" data-title="ID" v-if="user.type === 'show'">{{ user.id }}</td>
            <td class="name-cell cellpadding border-1-20" data-title="ID and full name:" v-if="user.type === 'show'">
              <span v-if="getDeviceType('tablet') || getDeviceType('mobile')">{{ user.id }} </span>
              {{ user.first_name || user.last_name ? (user.first_name ? user.first_name + ' ' : '') + (user.last_name ? user.last_name : '') : 'n/a' }}
            </td>
            <td class="email-cell cellpadding border-1-20" data-title="Email:" v-if="user.type === 'show'">{{ user.email ? user.email : 'n/a' }}</td>
            <td class="role-cell cellpadding border-1-20" data-title="Role:" v-if="user.type === 'show'">{{ user.role ? user.role.name : 'n/a' }}</td>
            <td class="title-cell cellpadding border-1-20" data-title="Title:" v-if="user.type === 'show'">{{ user.job_title ? user.job_title : 'n/a' }}</td>
            <td class="company-cell cellpadding border-1-20" data-title="Company:" v-if="user.type === 'show' && getUserRole === 'gm'">{{ user.company ? user.company.name : 'n/a' }}</td>
            <td class="created-cell cellpadding text-center border-1-20" data-title="Created on:" v-if="user.type === 'show'">{{ user.created ? lastActiveTime(user.created) : 'n/a' }}</td>
            <td class="last-login-cell cellpadding text-center border-1-20" data-title="Last login:" v-if="user.type === 'show'">{{ user.last_login ? lastActiveTime(user.last_login) : 'n/a' }}</td>
            <td class="status-cell cellpadding text-center border-1-20" data-title="Status:" v-if="user.type === 'show'">{{ getUserStatus(user) ? getUserStatus(user).label : 'n/a' }}</td>
          </tr>
          </tbody>
        </table>
        <div class="load-more-container" v-if="this.offset <= this.editedUsers.length">
          <div class="load-more-btn background-1-100" tabindex="0" @click="loadMore()">
            <div id="wave"><span class="dot"></span><span class="dot"></span><span class="dot"></span></div>Load more
          </div>
        </div>
      </div>
    </div>
    <app-spiner v-if="false" />
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters, mapActions } from 'vuex'
import AppSelect from '@/components/admin/common/Select'

export default {
  name: 'users-list',
  data () {
    return {
      ppt: 15,
      offset: 15,
      users: [],
      editedUsers: [],
      selectedAction: null,
      search: '',
      table: '',
      head: '',
      searchByName: '',
      searchEmail: '',
      hoverSearchElements: [],
      company: null,
      role: null,
      lastEdited: null,
      userStatus: [],
      userTitleList: [],
      userRoleList: [],
      userCompanyList: [],
      userStatusList: [],
      job_title: null,
      userType: null,
      userOrderBy: {
        type: 'login',
        order: false
      },
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      confirmation: {
        action: '',
        isShown: false,
        id: null,
        style: {
          top: '100px'
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      datepicker: {
        isShown: false,
        from: null,
        to: null
      },
      statusbar: {
        data: [],
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      windowWidth: window.innerWidth,
      allUserStatuses: []
    }
  },
  methods: {
    ...mapActions([
      // 'getRoles',
      // 'getCompanies',
      'setInformationMsg'
    ]),
    fetchAllContentByScroll (page, limit) {
      this.$http.get(api.URLS.users + '?limit=' + limit + '&page=' + page, api.headersAuthSettings)
        .then((res) => {
          this.users = res.body.data.items
          // for (let user in this.users) {
          //   this.checkSubscribe(this.users[user])
          // }
          this.statusbar.data = res.body.count ? res.body.count : []
          let query = this.$route.query
          if (query && query.role) {
            let role = this.users.filter(x => x.role.slug === query.role)[0].role
            this.role = {
              id: role.id,
              value: role.id,
              label: role.name
            }
          }
          this.userStatus = []
          if (query && query.status) {
            let userStatus = this.allUserStatuses.find((item) => item.label.toLowerCase() === query.status.toLowerCase())
            this.userStatus.push({
              value: userStatus.value,
              label: userStatus.label
            })
          } else {
            let preselectedStatuses = this.allUserStatuses.filter((item) => [0, 1, 7].indexOf(item.value) > -1)
            for (let index in preselectedStatuses) {
              this.userStatus.push({
                value: preselectedStatuses[index].value,
                label: preselectedStatuses[index].label
              })
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    discardСhanges (id) {
      for (let user of this.editedUsers) {
        if (user.id === id && user.type === 'edit') {
          user.type = null
        }
      }
    },
    addHoverElement (elements) {
      this.hoverElements = elements
    },
    addSearchHoverElement (type) {
      this.hoverSearchElements = type
    },
    removeHoverElements () {
      this.hoverElements = []
    },
    removeSearchHoverElements () {
      this.hoverSearchElements = ''
    },
    isExist (element) {
      if (element.type !== undefined && this.hoverSearchElements === element.type) {
        return true
      }
      let el = this.hoverElements.find(item => {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true
        }
      })
      return !!el
    },
    isExistInOptions (options) {
      let hoverElement = this.hoverElements.length ? this.hoverElements[0] : {}
      let el = false
      if (options) {
        el = options.find(item => {
          if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
            return true
          }
        })
      }
      return !!el
    },
    isExistSearchInOptions (type) {
      let hoverElement = this.hoverSearchElements ? this.hoverSearchElements : ''
      if (hoverElement === type) {
        return true
      }
    },
    removeSelectedFilters (filter) {
      if (this.searchByName) {
        this.searchByName = ''
      }
      if (this.searchEmail) {
        this.searchEmail = ''
      }
      if (this.role && this.role.label === filter.label && this.role.value === filter.value) {
        this.role = null
      }
      if (this.company && this.company.label === filter.label && this.company.value === filter.value) {
        this.company = null
      }
      if (this.lastEdited && this.lastEdited.label === filter.label && this.lastEdited.value === filter.value) {
        this.lastEdited = null
      }
      if (this.userStatus.length && this.userStatus.find((item) => item.label === filter.label && item.value === filter.value)) {
        let index = this.userStatus.findIndex((item) => item.label === filter.label && item.value === filter.value)
        this.userStatus.splice(index, 1)
      }
      if (this.job_title && this.job_title.label === filter.label) {
        this.job_title = null
      }
    },
    removeAllFilters () {
      this.searchByName = ''
      this.searchEmail = ''
      this.role = null
      this.company = null
      this.job_title = null
      this.lastEdited = null
      this.userStatus = []
    },
    showHideSubMenu (num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num
      }
    },
    hideSubMenuTableHead (e) {
      this.filerTableHead.selectedCeil = null
    },
    lastActiveTime (timestamp) {
      if (!timestamp) return ''
      let string = ''
      let loginAt = new Date(timestamp)
      let now = new Date()
      let difference = Math.floor((+now - +loginAt) / (1000 * 60 * 60))
      if (difference < 1) {
        string += 'less than 1 hour ago'
      } else if (difference >= 1 && difference < 24) {
        string += difference + ' hours ago'
      } else {
        string += this.convertDate(timestamp, '.')
      }
      return string
    },
    convertDate (payload, delimetr) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear
    },
    changeOrderBy (type, order) {
      this.userOrderBy = {
        type: type,
        order: this.userOrderBy !== null ? !this.userOrderBy.order : order
      }
    },
    goToUserEdit (id) {
      let props = this.$router.resolve({
        name: this.getUserRole === 'gm' ? 'edit-user' : 'ca-edit-user',
        params: {id: id}
      })
      this.$router.push(props.href)
    },
    loadMore () {
      this.offset = this.offset + this.ppt
    },
    handleWindowResize (event) {
      this.windowWidth = event.currentTarget.innerWidth
    },
    getDeviceType (check) {
      let width = this.windowWidth
      let deviceName = ''
      if (width >= 940) {
        deviceName = 'desktop'
      } else if (width >= 480) {
        deviceName = 'tablet'
      } else {
        deviceName = 'mobile'
      }
      return check === deviceName
    },
    getTabletFiltersAppliedText () {
      let filterAppliedText = 'Apply Filters'
      if (this.selectedFilters.length) {
        filterAppliedText = 'Filters applied: ' + this.editedUsers.length + ' results'
      }
      return filterAppliedText
    },
    getUserStatuses () {
      this.$http.get(api.URLS.userStatuses, api.headersAuthSettings)
        .then((res) => {
          this.allUserStatuses = res.body
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getUserStatus (user) {
      return this.allUserStatuses.find((item) => item.value === user.status)
    },
    csvExport (arrData) {
      let csvContent = [
        Object.keys(arrData[0]).map(function (item) {
          return '"' + item + '"'
        }).join(','),
        ...arrData.map(item => Object.values(item).map(function (item) {
          return '"' + item + '"'
        }).join(','))
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '')

      let csvData = new Blob([csvContent], {
        type: 'application/csv;charset=utf-8;'
      })

      if (window.navigator.msSaveBlob) {
        navigator.msSaveBlob(csvData, 'users-export.csv')
      } else {
        const csvUrl = URL.createObjectURL(csvData)
        const link = document.getElementById('csvDownload')
        link.setAttribute('href', csvUrl)
        link.setAttribute('download', 'users-export.csv')
        link.click()
      }
    },
    checkSubscribe (user) {
      this.$http.get(api.URLS.checkSubscribe + '/' + user.email, api.headersAuthSettings).then((res) => {
        user.subscribed = res.body
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  computed: {
    ...mapGetters([
      'getUserRole'
    ]),
    csvData () {
      const dataForExport = this.filteredUsers
      let self = this
      let data = dataForExport.map(function (item) {
        const status = self.getUserStatus(item)
        const gdpr = item.consent_status === 1 ? 'Accepted' : 'Not accepted'
        let newItem = {
          'First name': item.first_name ? item.first_name : 'n/a',
          'Last name': item.last_name ? item.last_name : 'n/a',
          'Email': item.email,
          'Company': item.company ? item.company.name : 'n/a',
          'Role': item.role ? item.role.name : 'n/a',
          'GDPR': gdpr,
          'Status': status ? status.label : 'n/a'
        }
        return newItem
      })

      return data
    },
    getStatusesForSelect () {
      return this.allUserStatuses
    },
    getCompaniesForSelect () {
      return this.userCompanyList
    },
    getRolesForSelect () {
      return this.userRoleList
    },
    getTitlesForSelect () {
      return this.userTitleList
    },
    filteredUsers () {
      let result = this.users
      result = this.users.filter((user) => (user.id + ' ' + user.first_name + ' ' + user.last_name).toLowerCase().indexOf(this.searchByName.toLowerCase()) > -1)
          .filter((user) => (user.email ? user.email : '').toLowerCase().indexOf(this.searchEmail.toLowerCase()) > -1)
          .filter((user) => this.company === null || (user.company && user.company.id === this.company.value))
          .filter((user) => this.role === null || (user.role && user.role.id === this.role.value))
          .filter((user) => !this.userStatus.length || (this.userStatus.find((item) => item.value === user.status)))
          .filter((user) => this.job_title === null || (user.job_title === this.job_title.label))
      if (this.userOrderBy !== null) {
        let ascDesc = this.userOrderBy.order ? 1 : -1
        if (this.userOrderBy.type === 'login') {
          return result.sort(function (a, b) {
            let firstDate = a.last_login !== undefined ? new Date(a.last_login) : ''
            let secondDate = b.last_login !== undefined ? new Date(b.last_login) : ''
            return ascDesc * (firstDate - secondDate)
          })
        } else {
          return result.sort(function (a, b) {
            let firstDate = a.created !== undefined ? new Date(a.created) : ''
            let secondDate = b.created !== undefined ? new Date(b.created) : ''
            return ascDesc * (firstDate - secondDate)
          })
        }
      } else {
        return result
      }
    },
    usersSum () {
      let count = 0
      if (this.getUserRole === 'gm') {
        this.statusbar.data.forEach(item => {
          count = count + +item.c
        })
      } else {
        count = this.users.length
      }
      return count
    },
    selectedFilters () {
      let filters = []
      if (this.searchByName) {
        filters.push({
          id: null,
          type: 'name',
          label: this.searchByName
        })
      }
      if (this.searchEmail) {
        filters.push({
          id: null,
          type: 'email',
          label: this.searchEmail
        })
      }
      if (this.company) {
        filters.push(this.company)
      }
      if (this.role) {
        filters.push(this.role)
      }
      if (this.job_title) {
        filters.push(this.job_title)
      }
      if (this.lastEdited) {
        filters.push(this.lastEdited)
      }
      if (this.userStatus) {
        for (let index in this.userStatus) {
          filters.push(this.userStatus[index])
        }
      }
      return filters
    }
  },
  watch: {
    filteredUsers () {
      let editedUsers = []
      this.offset = this.ppt
      this.userTitleList = []
      this.userRoleList = []
      this.userCompanyList = []
      this.userStatusList = []
      this.filteredUsers.forEach((user) => {
        user.type = 'show'
        if (user.company) {
          let index = this.userCompanyList.findIndex(x => x.label === user.company.name)
          if (index === -1) {
            this.userCompanyList.push({
              id: user.company.id,
              label: user.company.name,
              value: user.company.id
            })
          }
        }
        if (user.role) {
          let index = this.userRoleList.findIndex(x => x.label === user.role.name)
          if (index === -1) {
            this.userRoleList.push({
              id: user.role.id,
              label: user.role.name,
              value: user.role.id,
              slug: user.role.slug
            })
          }
        }
        if (user.job_title) {
          let index = this.userTitleList.findIndex(x => x.label === user.job_title)
          if (index === -1) {
            this.userTitleList.push({
              label: user.job_title,
              value: user.job_title
            })
          }
        }
        editedUsers.push(user)
      })
      this.editedUsers = editedUsers
    },
    'confirmation.isShown' (value) {
      if (value) {
        this.confirmation.style.top = window.pageYOffset - 100 + 'px'
      }
    }
  },
  components: {
    AppSelect
  },
  created () {
    document.title = 'All users | Clear Assured'
    this.$store.commit('setUserDimensions')
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname])
      window._paq.push(['setDocumentTitle', document.title])
      window._paq.push(['trackPageView'])
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name === 'ca-users' ? 'DASHBOARD_AREA' : 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  beforeMount () {
    this.getUserStatuses()
  },
  mounted () {
    this.fetchAllContentByScroll(1, 5000)
    // this.getRoles()
    // this.getCompanies()
    document.addEventListener('click', this.hideSubMenuTableHead)
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  destroyed () {
    document.addEventListener('click', this.hideSubMenuTableHead)
  }
}
</script>

<style src='@/assets/scss/components/table.scss' lang='scss' ></style>



// WEBPACK FOOTER //
// UsersList.vue?218222c3